import MmenuLight from 'mmenu-light';
import Swiper, {Autoplay} from 'swiper';
import * as L from 'leaflet/dist/leaflet-src.esm.js';

Swiper.use([Autoplay]);

function initMmenuLight() {
	// Ajouter l'entrée du niveau x au niveau x-1
	var mainMenu = document.querySelector('.m-main-menu')
  mainMenu.querySelectorAll('li').forEach(function(item,i) {
    var sub = item.querySelector('ul')
    if(sub !== null){
      var link = item.querySelector('a')
      var new_link = document.createElement('li')
      new_link.appendChild(link.cloneNode(true))
			new_link.classList.add('--mmenu-element')
      sub.prepend(new_link)

      // replace <a> by a <span>
      var span = document.createElement('span')
      span.innerHTML = link.innerHTML
			span.classList.add('--mmenu-element')
      item.prepend(span)
      link.classList.add('--mmenu-alien')
    }
  });

	// Breakpoint at which Mmenu is turned off
	var breakpoint = getComputedStyle(document.body).getPropertyValue('--vp-breakpoint-desktop');
	breakpoint = breakpoint.replace('px','')-1;

	var menuContainer = new MmenuLight(
    document.querySelector( "#navigation" ),
    "(max-width: "+breakpoint+"px)"
  );
  var drawer = menuContainer.offcanvas({
    position: 'right'
  });

  var menuNav = new MmenuLight(
    document.querySelector( ".m-main-menu" ),
    "(max-width: "+breakpoint+"px)"
  );
  var nav = menuNav.navigation({
    selected: 'selected',
    slidingSubmenus: true,
    title: ''
  });
//*/
  var toggleMenuTogglerClass = function(){
    document.querySelector( "a[href='#navigation']" ).classList.toggle('opened');
  };
  document.querySelector( "a[href='#navigation']" )
          .addEventListener( "click", function(evt){
              evt.preventDefault();
              if(this.classList.contains('opened')){
                drawer.close();
              }else{
                drawer.open();
              }
              toggleMenuTogglerClass();
          });

  document.querySelector( ".mm-ocd__backdrop" ).addEventListener( "click", toggleMenuTogglerClass);
	//*/

  // Close Mmenu when click on anchor link
  document.querySelectorAll( ".m-main-menu a" ).forEach(function(link){

    link.addEventListener('click', function(event){
      
      if(event.target.classList.contains('is-active')){
        drawer.close();
        toggleMenuTogglerClass();
      }
      
    });

  });

}
document.addEventListener('DOMContentLoaded', initMmenuLight);

function initSliders(){
	var sliders = document.querySelectorAll('.m-slider');

	if(sliders){
		sliders.forEach(function(el){
			var swiper = new Swiper(el, {
				slideClass: 'm-media',
				wrapperClass: 'm-slider-wrapper',
				loop: true,
				autoplay: {
					delay: 5000,
				}
			});
			el.querySelector('.m-slider-prev').addEventListener('click', function(){
				swiper.slidePrev();
			});
			el.querySelector('.m-slider-next').addEventListener('click', function(){
				swiper.slideNext();
			});
		});
	}
}
document.addEventListener('DOMContentLoaded', initSliders);

function initMagasinMap(){
	var map_magasin = document.getElementById('map_magasin');
	var magasin = document.querySelector('.t-magasin');

	if(map_magasin && magasin){
		var lat = magasin.querySelector('meta[itemprop="latitude"]').getAttribute('content');
		var lng = magasin.querySelector('meta[itemprop="longitude"]').getAttribute('content');
		var mymap = L.map('map_magasin').setView([lat, lng], 13);

		L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
	  	maxZoom: 19,
	  	attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
	  }).addTo(mymap);

		L.circleMarker([lat, lng],{
			stroke: 0,
			color: '#000',
			fillColor: '#49A948',
			fillOpacity: 1,
			radius: 15
		}).addTo(mymap);
	}
}
document.addEventListener('DOMContentLoaded', initMagasinMap);

function initMagasinsMap(){
	var map_magasins = document.getElementById('map_magasins');
	var magasins = document.querySelectorAll('.t-magasin-adresse');

	if(map_magasins && magasins.length > 0){
		var mymap = L.map('map_magasins').setView([0,0],13);

		L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
	  	maxZoom: 19,
	  	attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
	  }).addTo(mymap);

		var featureGroup = L.featureGroup();
		featureGroup.addTo(mymap);

		magasins.forEach(function(magasin){
			var lat = magasin.dataset.lat;
			var lng = magasin.dataset.lng;

			L.circleMarker([lat, lng],{
				stroke: 0,
				color: '#000',
				fillColor: '#49A948',
				fillOpacity: 1,
				radius: 15
			})
			.bindPopup(magasin.innerHTML)
			.addTo(featureGroup);

		});

		mymap.fitBounds(featureGroup.getBounds());
		//mymap.zoomOut();
	}
}
document.addEventListener('DOMContentLoaded', initMagasinsMap);

function initTeaserClick() {
	var teasers = document.querySelectorAll('.teaser');
	if(teasers.length > 0){
		teasers.forEach(function(el){
			el.addEventListener('click', function(){
				window.location = el.querySelector('a').getAttribute('href');
			});
		});
	}
}
document.addEventListener('DOMContentLoaded', initTeaserClick);

function initTitlesDecorationHack() {
	var titles = document.querySelectorAll('#block-contenudelapageprincipale h1, #block-contenudelapageprincipale h2');
	if(titles.length > 0){
		titles.forEach(function(el){
			var content = el.innerHTML;
			el.innerHTML = `<span>${content}</span>`;
		});
	}
}
document.addEventListener('DOMContentLoaded', initTitlesDecorationHack);
